import styled from 'styled-components';
import { tableWithStyles } from './tableStyles';
export var StyledNode = styled.div.withConfig({
  displayName: "partials__StyledNode",
  componentId: "sc-1bshul6-0"
})(["&&&{", "}"], function (_ref) {
  var customCSS = _ref.customCSS;
  return customCSS ? customCSS : '';
});
export var AutocloseNode = styled.div.withConfig({
  displayName: "partials__AutocloseNode",
  componentId: "sc-1bshul6-1"
})(["&&&{", "}"], function (_ref2) {
  var customCSS = _ref2.customCSS;
  return customCSS ? customCSS : '';
});
export var TableWrapper = styled.div.withConfig({
  displayName: "partials__TableWrapper",
  componentId: "sc-1bshul6-2"
})(["overflow:auto;max-width:100%;", ""], function (_ref3) {
  var _ref3$withStyles = _ref3.withStyles,
    withStyles = _ref3$withStyles === void 0 ? false : _ref3$withStyles;
  return withStyles && tableWithStyles;
});